import { c as _c } from "react/compiler-runtime";
import { focusRingClassName } from "@/components/ui/control-surface";
import Link from "next/link";
import type { ReactNode } from "react";
import cn from "twsx";

// A whole card that navigates: title over an optional two-line description.
export function CardLink(t0) {
  const $ = _c(12);
  const {
    description,
    href,
    prefetch: t1,
    title
  } = t0;
  const prefetch = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn(focusRingClassName, "flex min-h-20 w-full items-center px-5 py-4 text-left text-text-primary", "rounded-settings-list-view-item border border-border-popover bg-bg-surface", "hover:border-border-secondary hover:bg-fill-hover-subtle");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <span className="text-base font-medium">{title}</span>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== description) {
    t4 = description && <span className="line-clamp-2 text-base leading-5 text-text-tertiary">{description}</span>;
    $[3] = description;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <span className="flex min-w-0 flex-1 flex-col gap-1">{t3}{t4}</span>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== href || $[9] !== prefetch || $[10] !== t5) {
    t6 = <Link href={href} prefetch={prefetch} className={t2}>{t5}</Link>;
    $[8] = href;
    $[9] = prefetch;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}

// A navigating row inside a card list (report links, shortcuts) with
// optional trailing controls that sit outside the link.
/** Use when a card lists links to other pages. */
export function CardLinkRow(t0) {
  const $ = _c(7);
  const {
    actions,
    children,
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn(focusRingClassName, "flex min-w-0 flex-1 items-center gap-2 rounded-md px-2.5 py-1.5 text-base text-text-primary");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== href) {
    t2 = <Link href={href} className={t1}>{children}</Link>;
    $[1] = children;
    $[2] = href;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== actions || $[5] !== t2) {
    t3 = <div className="group flex min-h-9 items-center gap-1 rounded-md pr-1 hover:bg-fill-hover">{t2}{actions}</div>;
    $[4] = actions;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}